import styled, { createGlobalStyle } from 'styled-components';

import { ReactComponent as MailOpenOutline } from '../../../assets/icons/mail-open-outline.svg';

interface SelectedProps {
  selected?: boolean;
}

export const GlobalStyle = createGlobalStyle`
  .selected {
    border-color: ${(props) => props.theme.colors.primary};
    border-style: solid;
    border-width: 1px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  font-size: 15px;
  height: 76px;
  box-shadow: -4px -4px 8px rgba(36, 36, 36, 0.1),
    4px 4px 6px rgba(36, 36, 36, 0.1);
  border-radius: ${(props) =>
    Number(props.theme.radiusCards) ? `${props.theme.radiusCards}px` : '60px'};

  margin: 12px 0;
  background: #fff;
  padding: 15px 30px 15px 30px;

  &:hover {
    cursor: pointer;
  }

  @media screen and (max-width: 960px) {
    border-radius: ${(props) =>
      Number(props.theme.radiusCards)
        ? `${props.theme.radiusCards}px`
        : '10px'};
    width: 100%;
    padding: 20px 17px;
    font-size: 14px;
    height: 90px;
  }
`;

export const MailContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;

  @media screen and (max-width: 960px) {
    justify-content: space-between;
    width: 95%;
  }

  @media screen and (max-width: 600px) {
    justify-content: space-between;
    width: 100%;
  }
`;

export const Section = styled.div`
  display: flex;
  align-items: center;
`;

export const IconWMailOpenOutline = styled(MailOpenOutline)`
  width: 28px;
  height: 28px;
`;

export const EmailTitle = styled.div`
  width: auto;
  font-family: ${(props) => props.theme.primaryFont};
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 14px;
  color: ${(props) => props.theme.colors.black};
  margin-bottom: 8px;

  @media screen and (max-width: 960px) {
  }
`;

export const Email = styled.span`
  font-family: ${(props) => props.theme.primaryFont};
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 14px;
  color: #222222;
`;

export const Texts = styled.div`
  display: flex;
  flex-direction: column;
  width: 440px;
  margin: 0 54px 0 20px;
  @media screen and (max-width: 960px) {
    width: auto;
    margin: 0 0 0 12px;
  }
`;

export const SelectContainer = styled.div<SelectedProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  border: ${(props) =>
    `2px solid ${props.selected ? props.theme.colors.primary : '#7B86A3'}`};
  min-height: 24px;
  min-width: 24px;
  border-radius: 50%;
  align-self: center;
  cursor: pointer;
  span {
    background: ${(props) =>
      props.selected ? props.theme.colors.primary : 'none'};
    align-self: center;
    justify-self: center;
    height: 14px;
    width: 14px;
    border-radius: 50%;
  }
`;
